module.exports = "/_next/static/images/Lenard_Sweeting-3fdf1e23ac8c0ace9043634a83be54ba.webp";